// extracted by mini-css-extract-plugin
export default {"container":"ShipmentInvoiceFormInvoiceList_container__w7-Mu"};